import styled from 'styled-components'

interface ExpenseTypeTileLabelStyledProps {
  isActive: boolean
}

export const ExpenseTypeTileLabelStyled = styled.span<ExpenseTypeTileLabelStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(14)};
  font-weight: 500;
  line-height: ${(props) => props.theme.typography.pxToRem(16)};
  color: ${(props) =>
    props.isActive
      ? props.theme.colors.primary
      : props.theme.colors.text.primary};
`
